import React from 'react';
import { Alert } from '@shared/components';

interface AgreementPendingNoticeProps {
    quoteRef: string;
}

// Inline and persistent, not a toast: the outcome lands tens of seconds after completion.
// `role="status"`, not "alert" — this is informational about an already-successful sale.
export const AgreementPendingNotice: React.FC<AgreementPendingNoticeProps> = ({ quoteRef }) => {
    return (
        <Alert variant="warning" role="status" className="block">
            <p className="font-medium">This sale is completed. Its agreement has not been created yet.</p>
            <p className="mt-1">
                This usually resolves within a few minutes. If the agreement is still missing,
                quote reference <strong>{quoteRef}</strong> to support.
            </p>
        </Alert>
    );
};
